import { CapoPlugin } from "/home/runner/work/vaneerd-werkenbij/vaneerd-werkenbij/website/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];